// The edge function's own { error } message from a functions.invoke error, else the generic one.
// error.context is the fetch Response for HTTP errors and the thrown error for network failures.
export async function functionErrorMessage(error: { message: string; context?: unknown }): Promise<string> {
  const body = await (error.context as Response | undefined)?.json?.().catch(() => null);
  return typeof body?.error === 'string' && body.error ? body.error : error.message;
}
